import React from "react";
import { Link } from "gatsby";

const PageBreadcrumb = ({
  homePageUrl,
  homePageText,
  activePageText,
  modul,
}) => {
  return (
    <div
      className={
        modul === "tra"
          ? "page-breadcrumb-area-tra"
          : modul === "perf"
          ? "page-breadcrumb-area-perf"
          : "page-breadcrumb-area"
      }
    >
      <div className="page-breadcrumb">
        <nav className="page-title-content bg-white">
          <ul className="rounded">
            <li>
              <Link to={homePageUrl}>{homePageText}</Link>
            </li>
            <li>{activePageText}</li>
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default PageBreadcrumb;
